import * as yup from "yup";
import { passwordStrength } from "Utils/passwordStrength";


declare module "yup" {
   export interface StringSchema {      
      passwordStrength(): StringSchema;
   }
}
const YUP_NAME_METHOD = "passwordStrength";
yup.addMethod(yup.string, YUP_NAME_METHOD, function yupPasswordStrength() {   
   return this.test(YUP_NAME_METHOD, (d) => {
      const passwordStrengthResult = passwordStrength(d.value);
      return passwordStrengthResult.errors[0] || "Password is too weak";
   }, (value: string | undefined) => {
      if (LiquidSpaceConfig && LiquidSpaceConfig.DisablePasswordStrengthCheck)
         return true;
      else
         return passwordStrength(value).id >= 2;
   });
});
